(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3004],{

/***/ 88660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_skeleton_theme; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/atoms/custom-skeleton-theme/CustomSkeletonTheme.tsx


/**
 * CustomSkeletonTheme
 */ var CustomSkeletonTheme = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
        baseColor: "#F8F7F4" // Color base
        ,
        highlightColor: "#F4F0EB" // Color de las olas
        ,
        inline: true,
        borderRadius: 0,
        children: children
    });
};
CustomSkeletonTheme.displayName = "CustomSkeletonTheme";

;// CONCATENATED MODULE: ./components/atoms/custom-skeleton-theme/index.ts

/* harmony default export */ var custom_skeleton_theme = (CustomSkeletonTheme);


/***/ }),

/***/ 12116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ InputAtom; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Input_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16401);
/* harmony import */ var _Input_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Input_module_css__WEBPACK_IMPORTED_MODULE_4__);





/**
 * Primary UI component for user interaction
 */ var InputAtom = function(_param) {
    var type = _param.type, field = _param.field, name = _param.name, hidden = _param.hidden, _className = _param.className, className = _className === void 0 ? "" : _className, touched = _param.touched, error = _param.error, handleBlur = _param.handleBlur, handleChange = _param.handleChange, value = _param.value, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _handleFocus = _param.handleFocus, handleFocus = _handleFocus === void 0 ? function() {} : _handleFocus, _maxLength = _param.maxLength, maxLength = _maxLength === void 0 ? 524288 : _maxLength, id = _param.id, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "type",
        "field",
        "name",
        "hidden",
        "className",
        "touched",
        "error",
        "handleBlur",
        "handleChange",
        "value",
        "disabled",
        "handleFocus",
        "maxLength",
        "id"
    ]);
    if (type == "number") {
        field.value = parseInt(field.value);
    }
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), selected = ref[0], setSelected = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (type == "radio" && selected != field.value) {
            setSelected(field.value);
            handleChange(field.value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        value
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var onBlur = field.onBlur, onChange = field.onChange, onFocus = field.onFocus;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        disabled: disabled,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: type,
        value: field.value,
        required: true,
        maxLength: maxLength,
        id: id,
        className: "\n      ".concat((_Input_module_css__WEBPACK_IMPORTED_MODULE_4___default()["o-input__field"]), "\n      ").concat(hidden ? (_Input_module_css__WEBPACK_IMPORTED_MODULE_4___default()["o-input__field--hidden"]) : "", "\n      ").concat(touched && error ? (_Input_module_css__WEBPACK_IMPORTED_MODULE_4___default()["o-input__field--error"]) : "", "\n      ").concat(className, "    ")
    }, props));
};


/***/ }),

/***/ 58736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ price; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/atoms/custom-skeleton-theme/index.ts + 1 modules
var custom_skeleton_theme = __webpack_require__(88660);
// EXTERNAL MODULE: ./lib/utils/price.ts
var utils_price = __webpack_require__(86359);
// EXTERNAL MODULE: ./components/atoms/price/Price.module.css
var Price_module = __webpack_require__(31337);
var Price_module_default = /*#__PURE__*/__webpack_require__.n(Price_module);
;// CONCATENATED MODULE: ./components/atoms/price/Price.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            ",
        "\n            ",
        "\n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 * Price
 */ var Price = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _isDescription = param.isDescription, isDescription = _isDescription === void 0 ? false : _isDescription, regularPrice = param.regularPrice, price = param.price, quantity = param.quantity, loading = param.loading;
    var hasDiscount = price !== regularPrice && regularPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_skeleton_theme/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,es/* oneLine */.f9)(_templateObject(), (Price_module_default())["c-price"], isDescription ? (Price_module_default())["c-price--description"] : "", className),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    hasDiscount && regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Price_module_default())["c-price__regular-price"],
                        children: (0,utils_price/* toCurrency */.j3)(regularPrice)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,es/* oneLine */.f9)(_templateObject1(), (Price_module_default())["c-price__price"], hasDiscount ? (Price_module_default())["c-price__price-sale"] : ""),
                        children: loading || !price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                            containerClassName: "min-w-[40px] block"
                        }) : (0,utils_price/* toCurrency */.j3)(price)
                    }),
                    quantity && price && quantity !== 0 && quantity !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "u-font-card u-font-card--subtitle text-typo-secondary",
                        children: [
                            "Unidad: ",
                            (0,utils_price/* toCurrency */.j3)((0,utils_price/* priceToNumber */.Sk)(price) / quantity)
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/atoms/price/index.ts

/* harmony default export */ var price = (Price);


/***/ }),

/***/ 63480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cart_line; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 112 modules
var formik_esm = __webpack_require__(17417);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./components/icons/Trash.tsx
var Trash = __webpack_require__(52609);
// EXTERNAL MODULE: ./components/atoms/custom-skeleton-theme/index.ts + 1 modules
var custom_skeleton_theme = __webpack_require__(88660);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/atoms/text/index.ts + 1 modules
var atoms_text = __webpack_require__(61150);
// EXTERNAL MODULE: ./components/atoms/price/index.ts + 1 modules
var atoms_price = __webpack_require__(58736);
// EXTERNAL MODULE: ./components/molecules/icon-button/index.ts + 1 modules
var icon_button = __webpack_require__(2234);
// EXTERNAL MODULE: ./components/icons/Less.tsx
var Less = __webpack_require__(91175);
// EXTERNAL MODULE: ./components/icons/Add.tsx
var Add = __webpack_require__(40887);
// EXTERNAL MODULE: ./components/atoms/input/Input.tsx
var Input = __webpack_require__(12116);
// EXTERNAL MODULE: ./components/molecules/input/number/number.module.css
var number_module = __webpack_require__(31925);
var number_module_default = /*#__PURE__*/__webpack_require__.n(number_module);
;// CONCATENATED MODULE: ./components/molecules/input/number/Number.tsx





/**
 * Primary UI component for user interaction
 */ var NumberInput = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, name = param.name, _onChange = param./* eslint-disable-next-line @typescript-eslint/no-empty-function */ onChange, onChange = _onChange === void 0 ? function() {} : _onChange, error = param.error, disabled = param.disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (number_module_default())["o-number"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                name: name,
                children: function(param) {
                    var field = param.field;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (number_module_default())["o-number__wrapper"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "              ".concat((number_module_default())["o-number__less"], "               ").concat(disabled && (number_module_default())["o-number__less--disabled"], "            "),
                                onClick: function() {
                                    if (!disabled) onChange(parseInt(field.value) - 1);
                                },
                                "aria-disabled": disabled,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Less/* Less */.v, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* InputAtom */.U, {
                                hidden: true,
                                field: field,
                                name: name,
                                type: "number",
                                error: error,
                                value: field.value,
                                className: "              ".concat((number_module_default())["o-number__field"], "               ").concat(error ? (number_module_default())["o-number__field--error"] : "", "               ").concat(className, "            "),
                                // TODO: Añadir tipos
                                checked: true,
                                handleBlur: field.onBlur,
                                handleChange: field.onChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "               border border-primary-200 pt-[3px]\n              ".concat((number_module_default())["o-number__field"], "               ").concat(error ? (number_module_default())["o-number__field--error"] : "", "               ").concat(className, "            "),
                                children: field.value
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    if (!disabled) onChange(parseInt(field.value) + 1);
                                },
                                className: "              ".concat((number_module_default())["o-number__more"], "               ").concat(disabled && (number_module_default())["o-number__more--disabled"], "            "),
                                "aria-disabled": disabled,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* Add */.m, {})
                            })
                        ]
                    });
                }
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (number_module_default())["o-number__errorMessage"],
                children: error
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/input/number/index.ts

/* harmony default export */ var number = (NumberInput);

// EXTERNAL MODULE: ./lib/utils/price.ts
var utils_price = __webpack_require__(86359);
// EXTERNAL MODULE: ./components/molecules/cart-line/CartLine.module.css
var CartLine_module = __webpack_require__(65066);
var CartLine_module_default = /*#__PURE__*/__webpack_require__.n(CartLine_module);
;// CONCATENATED MODULE: ./components/molecules/cart-line/CartLine.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          ",
        "\n          ",
        "\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var QuantitySchema = (0,index_esm/* object */.Ry)().shape({
    quantity: (0,index_esm/* number */.Rx)().required()
});
/**
 * CartLine
 */ var CartLine = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, link = param.link, _size = param.size, size = _size === void 0 ? "normal" : _size, image = param.image, name = param.name, description = param.description, _quantity = param.quantity, quantity = _quantity === void 0 ? 1 : _quantity, price = param.price, _regularPrice = param.regularPrice, regularPrice = _regularPrice === void 0 ? "" : _regularPrice, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, onChange = param.onChange, onRemove = param.onRemove, loading = param.loading, _editable = param.editable, editable = _editable === void 0 ? true : _editable;
    // TODO: Añadir tipos
    var initialValues = {
        quantity: quantity
    };
    var formikRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (editable && !loading && formikRef.current) {
            formikRef.current.setFieldValue("quantity", quantity);
        }
    }, [
        quantity
    ]);
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_skeleton_theme/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,es/* oneLine */.f9)(_templateObject(), (CartLine_module_default())["c-cart-line"], size !== "normal" ? (CartLine_module_default())["c-cart-line--large"] : "", className),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CartLine_module_default())["c-cart-line__content"],
                children: [
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                        className: (CartLine_module_default())["c-cart-line__image"]
                    }) : link && image && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                        href: link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (CartLine_module_default())["c-cart-line__image"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "w-full",
                                layout: "fill",
                                src: image.src,
                                alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "",
                                draggable: "false",
                                objectPosition: "center",
                                objectFit: "contain"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-grow flex-col justify-between gap-y-4 pl-4 md:py-3 md:pl-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-start justify-between gap-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full",
                                        children: [
                                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                className: (CartLine_module_default())["c-cart-line__name"],
                                                containerClassName: "block w-full"
                                            }) : link && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                href: link,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (CartLine_module_default())["c-cart-line__name"],
                                                    children: name
                                                })
                                            }),
                                            description && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "u-font-card u-font-card--subtitle text-typo-secondary",
                                                children: description
                                            }),
                                            quantity && price && quantity > 1 && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "u-font-card u-font-card--subtitle text-typo-secondary",
                                                children: [
                                                    "Unidad: ",
                                                    (0,utils_price/* toCurrency */.j3)((0,utils_price/* priceToNumber */.Sk)(price) / quantity)
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    onRemove && !loading && editable && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_button/* default */.Z, {
                                        size: "small",
                                        style: "outline",
                                        disabled: disabled || loading,
                                        onClick: onRemove,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trash/* Trash */.r, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-end justify-between gap-x-5",
                                children: [
                                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        className: "h-8",
                                        containerClassName: "w-20 block"
                                    }) : editable && onChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        onSubmit: function() {},
                                        initialValues: initialValues,
                                        validationSchema: QuantitySchema,
                                        innerRef: formikRef,
                                        enableReinitialize: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(number, {
                                                name: "quantity",
                                                placeholder: "quantity",
                                                id: "quantity",
                                                disabled: disabled || loading,
                                                onChange: onChange
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms_text/* default */.Z, {
                                        className: "u-body u-body--xs font-bold",
                                        children: [
                                            quantity,
                                            " uds."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_price/* default */.Z, (0,_object_spread/* default */.Z)({}, loading ? {
                                        loading: true
                                    } : {
                                        price: price !== null && price !== void 0 ? price : "",
                                        regularPrice: regularPrice
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/cart-line/index.ts

/* harmony default export */ var cart_line = (CartLine);


/***/ }),

/***/ 30650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ modal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 7 modules
var dialog = __webpack_require__(91247);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(3967);
// EXTERNAL MODULE: ./lib/hooks/useFixSafariPortal.ts
var useFixSafariPortal = __webpack_require__(78023);
// EXTERNAL MODULE: ./lib/hooks/useRouteChangeStart.ts
var useRouteChangeStart = __webpack_require__(60556);
;// CONCATENATED MODULE: ./components/molecules/modal/Modal.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                ",
        "\n                ",
        "\n                relative inline-block w-full transform overflow-hidden text-left align-bottom shadow-xl transition-all sm:my-8 sm:align-middle\n              "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                        w-full max-w-md\n                        ",
        "\n                      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 * Primary UI component for user interaction
 */ var Modal = function(param) {
    var _open = param.open, open = _open === void 0 ? false : _open, setOpen = param.setOpen, children = param.children, _background = param.background, background = _background === void 0 ? "bg-bg-secondary" : _background, _onClose = param./* eslint-disable-next-line @typescript-eslint/no-empty-function */ onClose, onClose = _onClose === void 0 ? function() {} : _onClose, _noMaxWidthDesktop = param.noMaxWidthDesktop, noMaxWidthDesktop = _noMaxWidthDesktop === void 0 ? false : _noMaxWidthDesktop, _unmount = param.unmount, unmount = _unmount === void 0 ? false : _unmount;
    var close = function() {
        onClose();
        setOpen(false);
    };
    if (true) {
        setTimeout(function() {
            var elements = document.querySelectorAll("[id^=headlessui-dialog]");
            elements.forEach(function(el) {
                el.scrollTop = 0;
            });
        }, 200);
    }
    (0,useFixSafariPortal/* useFixSafariPortal */.s)(open);
    (0,useRouteChangeStart/* useRouteChangeStart */.R)(close);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        unmount: unmount,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.V, {
            as: "div",
            className: "fixed inset-0 z-50 overflow-y-auto",
            onClose: onClose,
            unmount: unmount,
            open: open,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex min-h-screen items-center justify-center py-4 px-4 text-center sm:block sm:p-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0",
                        enterTo: "opacity-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        unmount: unmount,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                            className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity",
                            onClick: close
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden sm:inline-block sm:h-screen sm:align-middle",
                        "aria-hidden": "true",
                        children: "​"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                        as: react.Fragment,
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        enterTo: "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        unmount: unmount,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,es/* oneLine */.f9)(_templateObject(), background, noMaxWidthDesktop ? "sm:max-w-max" : "sm:max-w-lg"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat(background, " p-6 sm:p-8"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: close,
                                        className: "absolute right-4 top-4 z-10 cursor-pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sm:flex sm:items-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex min-h-full w-full items-center justify-center pt-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (0,es/* oneLine */.f9)(_templateObject1(), noMaxWidthDesktop ? "lg:max-w-none" : ""),
                                                children: children
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/modal/index.ts

/* harmony default export */ var modal = (Modal);


/***/ }),

/***/ 60257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ prose; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/molecules/prose/Prose.module.css
var Prose_module = __webpack_require__(53264);
var Prose_module_default = /*#__PURE__*/__webpack_require__.n(Prose_module);
;// CONCATENATED MODULE: ./components/molecules/prose/Prose.tsx


/**
 * El componente prose da estilos al texto rico que
 * se recibe desde un CMS.
 */ var Prose = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, tmp = param.as, HTMLTag = tmp === void 0 ? "div" : tmp, html = param.html;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HTMLTag, {
        className: "prose max-w-full text-inherit ".concat((Prose_module_default())["c-prose"], " ").concat(className),
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
Prose.displayName = "Prose";

;// CONCATENATED MODULE: ./components/molecules/prose/index.ts

/* harmony default export */ var prose = (Prose);


/***/ }),

/***/ 17188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cart_lines; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/icons/Info.tsx
var Info = __webpack_require__(79817);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/molecules/modal/index.ts + 1 modules
var modal = __webpack_require__(30650);
;// CONCATENATED MODULE: ./components/molecules/cart-shipping-header/CartShippingHeader.tsx

/**
 * CartShippingHeader
 */ var CartShippingHeader = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "u-body bg-primary-100 px-3 py-2 text-primary-900 outline outline-1 outline-primary-100 md:p-4 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "u-body--s font-bold",
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "u-body--xs mt-1",
                children: description
            })
        ]
    });
};
CartShippingHeader.displayName = "CartShippingHeader";

;// CONCATENATED MODULE: ./components/molecules/cart-shipping-header/index.ts

/* harmony default export */ var cart_shipping_header = (CartShippingHeader);

// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./components/atoms/custom-skeleton-theme/index.ts + 1 modules
var custom_skeleton_theme = __webpack_require__(88660);
// EXTERNAL MODULE: ./lib/utils/orders.ts
var orders = __webpack_require__(11607);
;// CONCATENATED MODULE: ./components/molecules/cart-line-header/CartLineHeader.tsx




/**
 * CartLineHeader
 */ var CartLineHeader = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, title = param.title, description = param.description, _loading = param.loading, loading = _loading === void 0 ? false : _loading, status = param.status, buttons = param.buttons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_skeleton_theme/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col items-center gap-4 bg-white p-3 outline outline-1 outline-primary-100 sm:flex-row sm:px-6 ".concat(className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "u-body w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "u-body--s flex flex-row justify-between gap-6 sm:justify-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-bold uppercase",
                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        containerClassName: "w-52 block"
                                    }) : title
                                }),
                                status && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,orders/* getOrderStateColor */.C_)(status),
                                    children: status
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "u-body--xs text-typo-secondary",
                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {}) : description
                        })
                    ]
                }),
                buttons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex w-full flex-row gap-4 sm:w-auto sm:gap-6",
                    children: buttons
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/cart-line-header/index.ts

/* harmony default export */ var cart_line_header = (CartLineHeader);

// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
// EXTERNAL MODULE: ./components/molecules/cart-line/index.ts + 3 modules
var cart_line = __webpack_require__(63480);
// EXTERNAL MODULE: ./lib/utils/price.ts
var utils_price = __webpack_require__(86359);
;// CONCATENATED MODULE: ./components/molecules/cart-line-footer/CartLineFooter.tsx



/**
 * CartLineFooter
 */ var CartLineFooter = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, price = param.price, howMuchLeftForFreeShipping = param.howMuchLeftForFreeShipping, shippingIcon = param.shippingIcon, shippingLink = param.shippingLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-1 p-3 outline outline-1 outline-primary-100 md:px-6 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "u-body u-body--s flex justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "inline-flex gap-1",
                        children: [
                            "Gastos de env\xedo",
                            shippingIcon
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-bold uppercase",
                        children: price > 0 ? (0,utils_price/* toCurrency */.j3)(price) : "Gratis"
                    })
                ]
            }),
            howMuchLeftForFreeShipping && price > 0 && howMuchLeftForFreeShipping > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                href: shippingLink || "#flexible-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "u-body u-body--xs text-secondary-500 underline",
                    children: [
                        "Faltan ",
                        (0,utils_price/* toCurrency */.j3)(howMuchLeftForFreeShipping),
                        " para env\xedo gratuito"
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/cart-line-footer/index.ts

/* harmony default export */ var cart_line_footer = (CartLineFooter);

// EXTERNAL MODULE: ./components/providers/initPropsProvider.ts
var initPropsProvider = __webpack_require__(64613);
// EXTERNAL MODULE: ./lib/hooks/useCartDispatch.ts
var useCartDispatch = __webpack_require__(15707);
// EXTERNAL MODULE: ./lib/routes/index.ts
var routes = __webpack_require__(94696);
// EXTERNAL MODULE: ./lib/utils/image.ts
var utils_image = __webpack_require__(43688);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
// EXTERNAL MODULE: ./public/assets/images/fallback-product-card.jpg
var fallback_product_card = __webpack_require__(12357);
// EXTERNAL MODULE: ./stories/utils/collections.tsx
var collections = __webpack_require__(87007);
;// CONCATENATED MODULE: ./components/organisms/cart-lines/CartLines.tsx
















// TODO: Limpiar codigo, es muy confuso ahora mismo
/**
 * CartLines
 */ var CartLines = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, loading = param.loading, cart = param.cart, _editable = param.editable, editable = _editable === void 0 ? true : _editable, _type = param.type, type = _type === void 0 ? "cart" : _type, hookSeller = param.hookSeller;
    var ref;
    var ref1 = (0,react.useState)(false), isUpdating = ref1[0], setIsUpdating = ref1[1];
    var ref2 = (0,react.useState)(false), showModal = ref2[0], setShowModal = ref2[1];
    var propsProvider = (0,react.useContext)(initPropsProvider/* InitPropsProvider */.J);
    var bcOptions = propsProvider === null || propsProvider === void 0 ? void 0 : (ref = propsProvider.options) === null || ref === void 0 ? void 0 : ref.ajustesGenerales;
    var ref3 = (0,useCartDispatch/* useCartDispatch */.d)(), update = ref3.update, remove = ref3.remove;
    (0,react.useEffect)(function() {
        return function() {
            setIsUpdating(false);
        };
    }, []);
    var ref4, ref5, _remainingRefundQuantity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal["default"], {
                open: showModal,
                setOpen: setShowModal,
                unmount: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-4 md:mb-6",
                        children: "GASTOS DE ENV\xcdO"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "prose",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "El coste de env\xedo es de 5 € IVA incluido. El coste del env\xedo es gratuito para pedidos superiores a 50 €*."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Env\xedo solo a Espa\xf1a peninsular. Los pedidos tendr\xe1n un l\xedmite de peso de ",
                                    bcOptions.weightMaxCart,
                                    " kg. Para pedidos de un volumen superior p\xf3ngase en",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                        href: routes/* routes.contact */._.contact,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "text-secondary-500",
                                            children: [
                                                " ",
                                                "contacto con nuestro servicio de Atenci\xf3n al Cliente."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "* L\xedmite sujeto a promociones."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col gap-4 md:gap-6 ".concat(className),
                children: !loading && cart ? cart === null || cart === void 0 ? void 0 : cart.map(function(seller) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid w-full grid-cols-1 gap-px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_shipping_header, (0,_object_spread/* default */.Z)({
                                    title: "Vendido por ".concat(seller.name)
                                }, type === "order" && "orderNumber" in seller && {
                                    description: "N\xba ".concat((0,orders/* isOperator */.S6)(seller.name) ? "BC-".concat(seller.orderNumber) : "WPT-".concat(seller.orderNumber, "-A"))
                                })),
                                (0,_instanceof/* default */.Z)(seller.orders, Array) && seller.orders.map(function(order, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_line_header, (0,_object_spread/* default */.Z)({
                                                title: order.shippingEstimateDate.date
                                            }, type === "order" && "status" in seller && "tracking" in order && (0,_object_spread/* default */.Z)({
                                                status: seller.status
                                            }, (order === null || order === void 0 ? void 0 : order.tracking) && {
                                                buttons: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                                    as: "a",
                                                    href: order.tracking,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    label: "Localizar",
                                                    style: "secondary",
                                                    className: "!min-w-full md:!max-w-max"
                                                })
                                            }))),
                                            order.offers.map(function(offer) {
                                                var ref, ref1, ref2, ref3;
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(cart_line/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    editable: true,
                                                    disabled: isUpdating,
                                                    image: (0,utils_image/* imageWithFallback */.V)((ref4 = (ref = offer.product) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.sourceUrl) !== null && ref4 !== void 0 ? ref4 : "", (ref5 = (ref2 = offer.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.altText) !== null && ref5 !== void 0 ? ref5 : "", fallback_product_card/* default.src */.Z.src),
                                                    name: offer.product.name
                                                }, "description" in offer.product && offer.product.description && {
                                                    description: offer.product.description
                                                }, "remainingRefundQuantity" in offer ? {
                                                    quantity: (_remainingRefundQuantity = offer.remainingRefundQuantity) !== null && _remainingRefundQuantity !== void 0 ? _remainingRefundQuantity : offer.quantity
                                                } : {
                                                    quantity: offer.quantity
                                                }, editable && "key" in offer && {
                                                    onChange: function() {
                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        setIsUpdating(true);
                                                                        return [
                                                                            4,
                                                                            update(offer.key, value).catch(function(error) {
                                                                                return (0,utils/* debug */.fF)(error);
                                                                            })
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        setIsUpdating(false);
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        });
                                                        return function(value) {
                                                            return _ref.apply(this, arguments);
                                                        };
                                                    }(),
                                                    onRemove: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    setIsUpdating(true);
                                                                    return [
                                                                        4,
                                                                        remove(offer.key).catch(function(error) {
                                                                            return (0,utils/* debug */.fF)(error);
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    _state.sent();
                                                                    setIsUpdating(false);
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    })
                                                }), {
                                                    price: "remainingRefund" in offer && offer.remainingRefund ? (0,utils_price/* toCurrency */.j3)(offer === null || offer === void 0 ? void 0 : offer.remainingRefund) : (0,utils_price/* toCurrency */.j3)(offer.total)
                                                }), "regularPrice" in offer.product && offer.product.regularPrice && {
                                                    regularPrice: (0,utils_price/* toCurrency */.j3)((0,utils_price/* priceToNumber */.Sk)(offer.product.regularPrice) * offer.quantity)
                                                }), {
                                                    link: (0,utils/* removeBaseURL */.t7)(offer.product.link),
                                                    className: "bg-bg-secondary"
                                                }), offer.id);
                                            })
                                        ]
                                    }, index);
                                }),
                                type !== "order" && /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_line_footer, (0,_object_spread/* default */.Z)({
                                    className: "bg-bg-secondary",
                                    price: seller.shippingTotal
                                }, "minFreeAmount" in seller && seller.minFreeAmount && {
                                    howMuchLeftForFreeShipping: seller.minFreeAmount - seller.total
                                }, (0,orders/* isOperator */.S6)(seller.name) && {
                                    shippingIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return setShowModal(true);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* Info */.k, {
                                            width: 20,
                                            height: 20
                                        })
                                    })
                                }, "path" in seller && {
                                    shippingLink: seller.path
                                })),
                                typeof hookSeller === "function" ? hookSeller(seller) : hookSeller
                            ]
                        })
                    }, seller.id);
                }) : (0,collections/* repeat */.r)(2, /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid w-full grid-cols-1 gap-px bg-bg-secondary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_line_header, {
                                loading: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_line/* default */.Z, {
                                loading: true
                            })
                        ]
                    })
                }))
            })
        ]
    });
};
CartLines.displayName = "CartLines";

;// CONCATENATED MODULE: ./components/organisms/cart-lines/index.ts

/* harmony default export */ var cart_lines = (CartLines);


/***/ }),

/***/ 71667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/icons/ArrowRight.tsx
var ArrowRight = __webpack_require__(10997);
// EXTERNAL MODULE: ./components/icons/index.ts + 24 modules
var icons = __webpack_require__(72516);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/molecules/icon-button/index.ts + 1 modules
var icon_button = __webpack_require__(2234);
// EXTERNAL MODULE: ./components/molecules/prose/index.ts + 1 modules
var prose = __webpack_require__(60257);
// EXTERNAL MODULE: ./components/templates/flexible-content/FlexibleContent.tsx
var FlexibleContent = __webpack_require__(65900);
// EXTERNAL MODULE: ./components/providers/initPropsProvider.ts
var initPropsProvider = __webpack_require__(64613);
// EXTERNAL MODULE: ./lib/graphql/transformers/common/image.ts
var common_image = __webpack_require__(32226);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
;// CONCATENATED MODULE: ./components/organisms/footer/Footer.tsx












var BeerSubmarine = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3149).then(__webpack_require__.bind(__webpack_require__, 53149));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53149)
            ];
        }
    },
    ssr: false
});
var getMenu = function(menu) {
    var ref;
    return (ref = menu === null || menu === void 0 ? void 0 : menu.edges[0]) === null || ref === void 0 ? void 0 : ref.node;
};
// TODO tipar los datos
var Footer = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var propsProvider = (0,react.useContext)(initPropsProvider/* InitPropsProvider */.J);
    var menus = propsProvider === null || propsProvider === void 0 ? void 0 : propsProvider.menus;
    var ref9;
    var legal = (ref9 = getMenu(menus === null || menus === void 0 ? void 0 : menus.legal)) !== null && ref9 !== void 0 ? ref9 : {};
    var ref10;
    var col1 = (ref10 = getMenu(menus === null || menus === void 0 ? void 0 : menus.recommended)) !== null && ref10 !== void 0 ? ref10 : {};
    var ref11;
    var col2 = (ref11 = getMenu(menus === null || menus === void 0 ? void 0 : menus.about)) !== null && ref11 !== void 0 ? ref11 : {};
    var ref12;
    var col3 = (ref12 = getMenu(menus === null || menus === void 0 ? void 0 : menus.support)) !== null && ref12 !== void 0 ? ref12 : {};
    var ref13;
    var bcOptions = (ref13 = propsProvider === null || propsProvider === void 0 ? void 0 : (ref = propsProvider.options) === null || ref === void 0 ? void 0 : ref.ajustesGenerales) !== null && ref13 !== void 0 ? ref13 : {};
    var copyright = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.copyright;
    var ref14;
    var payments = (ref14 = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.payments) !== null && ref14 !== void 0 ? ref14 : [];
    var ref15;
    var socialNetworks = (ref15 = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.socialNetworks) !== null && ref15 !== void 0 ? ref15 : [];
    var newsletter = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.newsletter;
    var ref16;
    var flexibleContent = (ref16 = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.footerContent) !== null && ref16 !== void 0 ? ref16 : [];
    var legalText = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.legalText;
    var logo = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.logo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        "aria-labelledby": "footer-heading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                id: "footer-heading",
                className: "sr-only",
                children: "Footer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                wrapper: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-2 gap-x-8 gap-y-6 md:grid-cols-3 lg:grid-cols-[375px_repeat(3,_1fr)] lg:gap-y-4 xl:gap-x-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 md:order-4 md:col-span-1 lg:order-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-5 max-w-[375px] lg:mb-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, (0,common_image/* imageTransformer */.p)(logo)))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 md:order-1 md:col-span-2 md:row-span-3 lg:order-2 lg:col-span-1 lg:row-span-1 lg:row-start-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "grid max-w-[500px] grid-cols-3 gap-x-5 gap-y-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BeerSubmarine, {
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            // @ts-ignore
                                            className: "mx-auto max-w-[100px] lg:row-span-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-span-2 flex flex-col justify-center gap-4",
                                            children: [
                                                (newsletter === null || newsletter === void 0 ? void 0 : newsletter.tituloNewsletter) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "u-subtitle u-subtitle@mobile--l",
                                                    children: newsletter === null || newsletter === void 0 ? void 0 : newsletter.tituloNewsletter
                                                }),
                                                (newsletter === null || newsletter === void 0 ? void 0 : newsletter.textoNewsletter) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "u-body u-body--s text-typo-secondary",
                                                    children: newsletter === null || newsletter === void 0 ? void 0 : newsletter.textoNewsletter
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-full lg:col-span-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                onSubmit: function(e) {
                                                    return e.preventDefault();
                                                },
                                                id: "newsletter_form",
                                                className: "w-full",
                                                name: "newsletter_form",
                                                method: "POST",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "relative block w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            id: "newsletter_email",
                                                            type: "email",
                                                            placeholder: "Tu correo electr\xf3nico",
                                                            className: "w-full p-4 pr-16"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_button/* default */.Z, {
                                                            type: "submit",
                                                            id: "newsletter_submit",
                                                            size: "small",
                                                            className: "newsletter-trigger absolute right-4 top-1/2 -translate-y-1/2",
                                                            "aria-label": "Enviar",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* ArrowRight */.o, {
                                                                width: 20,
                                                                height: 14
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 flex flex-row flex-wrap gap-6 md:order-2 md:col-span-1 lg:order-6 lg:col-start-3",
                                children: payments === null || payments === void 0 ? void 0 : payments.map(function(item) {
                                    var Icon = icons[item.icon];
                                    return Icon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: item.icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }, item.icon) : null;
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-2 flex flex-row gap-6 md:order-3 md:col-span-1 lg:order-7",
                                children: socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.map(function(item) {
                                    var Icon = icons[item.icon];
                                    return Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: item.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: item.icon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    }, item.icon) : null;
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-2 flex flex-col gap-4 xs:col-span-1 md:order-5 lg:order-3 lg:row-span-2 lg:gap-6",
                                children: [
                                    (col1 === null || col1 === void 0 ? void 0 : col1.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "u-subtitle u-subtitle@mobile--l",
                                        children: col1 === null || col1 === void 0 ? void 0 : col1.name
                                    }),
                                    (col1 === null || col1 === void 0 ? void 0 : col1.menuItems) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "flex flex-col gap-4 lg:gap-6",
                                        children: col1 === null || col1 === void 0 ? void 0 : (ref1 = col1.menuItems) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nodes) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                    href: (0,utils/* removeBaseURL */.t7)(item.url),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "u-actions u-actions--link",
                                                        children: item.label
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-2 flex flex-col gap-4 xs:col-span-1 md:order-6 lg:order-4 lg:row-span-2 lg:gap-6",
                                children: [
                                    (col2 === null || col2 === void 0 ? void 0 : col2.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "u-subtitle u-subtitle@mobile--l",
                                        children: col2 === null || col2 === void 0 ? void 0 : col2.name
                                    }),
                                    (col2 === null || col2 === void 0 ? void 0 : col2.menuItems) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "flex flex-col gap-4 lg:gap-6",
                                        children: col2 === null || col2 === void 0 ? void 0 : (ref3 = col2.menuItems) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.nodes) === null || ref4 === void 0 ? void 0 : ref4.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                    href: (0,utils/* removeBaseURL */.t7)(item.url),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "u-actions u-actions--link",
                                                        children: item.label
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-2 flex flex-col gap-4 xs:col-span-1 md:order-7 lg:order-5 lg:row-span-2 lg:gap-6",
                                children: [
                                    (col3 === null || col3 === void 0 ? void 0 : col3.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "u-subtitle u-subtitle@mobile--l",
                                        children: col3 === null || col3 === void 0 ? void 0 : col3.name
                                    }),
                                    (col3 === null || col3 === void 0 ? void 0 : col3.menuItems) && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "flex flex-col gap-4 lg:gap-6",
                                        children: col3 === null || col3 === void 0 ? void 0 : (ref5 = col3.menuItems) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.nodes) === null || ref6 === void 0 ? void 0 : ref6.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                    href: (0,utils/* removeBaseURL */.t7)(item.url),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "u-actions u-actions--link",
                                                        children: item.label
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    legalText && /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
                        as: "div",
                        className: "u-wrapper pt-5",
                        html: legalText
                    })
                ]
            }),
            flexibleContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                wrapper: true,
                backgroundColor: "bg-bg-tertiary",
                padding: "p-0",
                className: "text-typo-alternative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexibleContent/* FlexibleContent */.U, {
                    type: "BcGeneralSettings",
                    typeFlexible: "Ajustesgenerales",
                    flexible: flexibleContent
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                wrapper: true,
                padding: "px-4 py-4",
                backgroundColor: "bg-bg-tertiary",
                className: "text-typo-alternative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "u-actions u-actions--link flex flex-col justify-center gap-10 text-center lg:flex-row lg:justify-between lg:text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            role: "list",
                            className: "flex flex-col gap-4 lg:flex-row lg:gap-12",
                            children: legal === null || legal === void 0 ? void 0 : (ref7 = legal.menuItems) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.nodes) === null || ref8 === void 0 ? void 0 : ref8.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                        href: (0,utils/* removeBaseURL */.t7)(item.url),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: item.label
                                        })
                                    })
                                }, index);
                            })
                        }),
                        copyright
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                wrapper: true,
                padding: "px-4 py-4",
                backgroundColor: "bg-bg-tertiary",
                className: "border-t border-primary-600 text-typo-alternative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "u-body u-body--s flex flex-col justify-center gap-10 text-center text-primary-400 lg:flex-row lg:justify-between lg:text-left",
                    children: "Estrella Galicia recomienda el consumo responsable. Prohibida la venta o suministro de bebidas alcoh\xf3licas a menores de 18 a\xf1os."
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/organisms/footer/index.ts

/* harmony default export */ var footer = (Footer);


/***/ }),

/***/ 21604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./lib/hooks/useRouteChangeStart.ts
var useRouteChangeStart = __webpack_require__(60556);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/hoc/conditional-wrapper/index.ts + 1 modules
var conditional_wrapper = __webpack_require__(70997);
// EXTERNAL MODULE: ./components/providers/initPropsProvider.ts
var initPropsProvider = __webpack_require__(64613);
;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Block/Block.tsx



/**
 * Primary UI component for user interaction
 */ var Block = function(param) {
    var block = param.block, parentMenuName = param.parentMenuName;
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "space-y-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                block.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(conditional_wrapper/* default */.Z, {
                    condition: Boolean(block.page),
                    wrapper: function(children) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                            href: block.page.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: children
                            })
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        id: "".concat(block.title, "-").concat(parentMenuName, "-heading"),
                        className: "u-body u-body--l mb-4 font-medium normal-case text-primary-900",
                        children: block.title
                    })
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    role: "list",
                    "aria-labelledby": "".concat(block.title, "-").concat(parentMenuName, "-heading"),
                    className: "mb-6 space-y-2",
                    children: // TODO: Añadir tipos
                    block.menuPages && block.menuPages.map(function(item) {
                        var ref, ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            className: "flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                href: item.pageUrl ? (ref = item.pageUrl) === null || ref === void 0 ? void 0 : ref.url : "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: item.pageUrl ? (ref1 = item.pageUrl) === null || ref1 === void 0 ? void 0 : ref1.url : "/",
                                    className: "u-body u-body--s my-0 normal-case text-primary-500 hover:text-primary-900",
                                    children: item.pageTitle
                                })
                            })
                        }, item.pageTitle);
                    })
                }),
                block.lastLinkTitle && block.lastLinkTitleUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                    href: ((ref = block.lastLinkTitleUrl) === null || ref === void 0 ? void 0 : ref.url) || "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "u-body u-body--s my-0 normal-case text-primary-900 hover:text-primary-500",
                        children: block.lastLinkTitle
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Block/index.ts

/* harmony default export */ var desktop_Block = (Block);

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Column/Column.tsx


/**
 * Primary UI component for user interaction
 */ var Column = function(param) {
    var column = param.column, parentMenuName = param.parentMenuName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "space-y-16",
        children: column.bloque && // TODO: Añadir tipos
        column.bloque.map(function(bloque, blockIndex) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_Block, {
                block: bloque,
                parentMenuName: parentMenuName
            }, blockIndex);
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Column/index.ts

/* harmony default export */ var desktop_Column = (Column);

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Flyout/FlyOut.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  absolute inset-x-0 top-[calc(100%-64px)] w-full transition-opacity\n                  ",
        "\n                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 * Primary UI component for user interaction
 */ var FlyOut = function(param) {
    var open = param.open, setOpen = param.setOpen;
    var timeOut;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "gap-6 lg:flex lg:w-full lg:items-start lg:justify-between",
        onMouseLeave: function() {
            return setOpen(-1);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(initPropsProvider/* InitPropsProvider.Consumer */.J.Consumer, {
            children: function(param) {
                var _menus = param.menus, menus = _menus.primaryMenu.menus;
                // TODO: Añadir tipos
                return menus === null || menus === void 0 ? void 0 : menus.map(function(category, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-16 items-center justify-center p-4",
                        onMouseEnter: function() {
                            if (!category.columnsNumber) setOpen(-1);
                            if (open !== -1) {
                                if (category.columnsNumber) setOpen(index);
                                return;
                            }
                            timeOut = setTimeout(function() {
                                if (category.columnsNumber) setOpen(index);
                            }, 400);
                        },
                        onMouseLeave: function() {
                            clearTimeout(timeOut);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-actions u-actions--nav relative z-10 flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(conditional_wrapper/* default */.Z, {
                                    condition: category.parentMenuLink,
                                    wrapper: function(children) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                            href: category.parentMenuLink.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: children
                                            })
                                        });
                                    },
                                    children: category.parentMenu
                                })
                            }),
                            category.columnsNumber && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,es/* oneLine */.f9)(_templateObject(), open === index ? "opacity-100" : "pointer-events-none opacity-0"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pt-16 text-sm text-gray-500",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0 top-1/2 bg-primary-50 shadow",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative z-50 bg-primary-50",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "u-wrapper border-t border-primary-100 px-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid grid-flow-col gap-x-8 gap-y-10 py-16",
                                                    children: [
                                                        category.menuImageActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-start-2 grid max-w-[250px] grid-flow-col gap-x-8",
                                                            children: category.imageLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                                href: category.imageLink.url,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    "aria-label": category.image.altText || "Imagen destacada",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: category.image.sourceUrl,
                                                                        width: category.image.mediaDetails.width,
                                                                        height: category.image.mediaDetails.height,
                                                                        alt: category.image.altText
                                                                    })
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: category.image.sourceUrl,
                                                                    width: category.image.mediaDetails.width,
                                                                    height: category.image.mediaDetails.height,
                                                                    alt: category.image.altText
                                                                })
                                                            })
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "row-start-1 grid grid-flow-col gap-x-8 gap-y-10 pr-[150px] text-sm",
                                                            children: category.column && category.column.map(// TODO: Añadir tipos
                                                            function(column, columnIndex) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_Column, {
                                                                    column: column,
                                                                    parentMenuName: category.parentMenu
                                                                }, columnIndex);
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, index);
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Flyout/index.ts

/* harmony default export */ var Flyout = (FlyOut);

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/DesktopMenu.tsx



/**
 * Primary UI component for user interaction
 */ var DesktopMenu = function(param) {
    var setOpen = param.setOpen, open = param.open;
    (0,useRouteChangeStart/* useRouteChangeStart */.R)(function() {
        return setOpen(-1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "aria-label": "Top",
        className: "u-wrapper !static z-50 hidden lg:block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flyout, {
            setOpen: setOpen,
            open: open
        })
    });
};

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/index.ts

/* harmony default export */ var desktop = (DesktopMenu);

// EXTERNAL MODULE: ./components/atoms/container/index.ts + 3 modules
var container = __webpack_require__(59203);
// EXTERNAL MODULE: ./components/icons/Search.tsx
var Search = __webpack_require__(26242);
;// CONCATENATED MODULE: ./components/algolia/facade-search-box-desktop/FacadeSearchBoxDesktop.tsx




var SearchBoxInstantSearch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9936), __webpack_require__.e(1913), __webpack_require__.e(585)]).then(__webpack_require__.bind(__webpack_require__, 90585));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90585)
            ];
        }
    },
    ssr: false
});
/**
 * FacadeSearchBoxDesktop
 */ var FacadeSearchBoxDesktop = function(param) {
    var placeholder = param.placeholder, className = param.className;
    var ref = (0,react.useState)(false), clicked = ref[0], setClicked = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "border-b border-b-primary-200 pb-4 ".concat(className),
        children: clicked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoxInstantSearch, {
            placeholder: placeholder
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex w-[360px] flex-row items-center gap-2 rounded-full bg-primary-100 pl-4 pr-8",
            onClick: function() {
                return setClicked(true);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* Search */.o, {
                    width: 20,
                    height: 20,
                    className: "flex-shrink-0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    placeholder: placeholder,
                    type: "text",
                    className: "u-body u-body--m block w-full border-0 bg-primary-100 px-0 py-2 align-baseline text-typo-primary placeholder-typo-tertiary focus:border-transparent focus:text-primary-900 focus:outline-none focus:ring-0"
                })
            ]
        })
    });
};
FacadeSearchBoxDesktop.displayName = "FacadeSearchBoxDesktop";

;// CONCATENATED MODULE: ./components/algolia/facade-search-box-desktop/index.ts

/* harmony default export */ var facade_search_box_desktop = (FacadeSearchBoxDesktop);

// EXTERNAL MODULE: ./lib/graphql/transformers/common/image.ts
var common_image = __webpack_require__(32226);
// EXTERNAL MODULE: ./lib/routes/index.ts
var routes = __webpack_require__(94696);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 7 modules
var dialog = __webpack_require__(91247);
// EXTERNAL MODULE: ./node_modules/search-insights/index-browser.cjs.js
var index_browser_cjs = __webpack_require__(41137);
var index_browser_cjs_default = /*#__PURE__*/__webpack_require__.n(index_browser_cjs);
// EXTERNAL MODULE: ./components/icons/Reload.tsx
var Reload = __webpack_require__(70719);
// EXTERNAL MODULE: ./components/icons/UserActive.tsx
var UserActive = __webpack_require__(46016);
// EXTERNAL MODULE: ./components/icons/User.tsx
var User = __webpack_require__(26507);
// EXTERNAL MODULE: ./components/icons/Cart.tsx
var Cart = __webpack_require__(55727);
// EXTERNAL MODULE: ./components/atoms/custom-skeleton-theme/index.ts + 1 modules
var custom_skeleton_theme = __webpack_require__(88660);
// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
// EXTERNAL MODULE: ./components/organisms/toast-center/index.tsx + 4 modules
var toast_center = __webpack_require__(47831);
// EXTERNAL MODULE: ./components/organisms/cart-lines/index.ts + 7 modules
var cart_lines = __webpack_require__(17188);
// EXTERNAL MODULE: ./lib/hooks/useCart.ts
var useCart = __webpack_require__(59197);
// EXTERNAL MODULE: ./lib/utils/price.ts
var price = __webpack_require__(86359);
// EXTERNAL MODULE: ./lib/utils/gtm/helpers.ts
var helpers = __webpack_require__(20457);
// EXTERNAL MODULE: ./lib/utils/gtm/normalizeCartItems.tsx
var normalizeCartItems = __webpack_require__(2671);
;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Toolbar/Toolbar.tsx

function Toolbar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        absolute right-0 -ml-2 \n        flex h-6 w-6\n         scale-0 items-center justify-center overflow-hidden rounded-full border-4 border-secondary-500 bg-secondary-500 text-center \n         font-mono text-sm font-medium text-white transition-transform \n         ",
        "\n         ",
        "\n      "
    ]);
    Toolbar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          -translate-y-[15px] transition-transform\n          ",
        "\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                absolute -right-5 top-0 flex w-[370px] flex-col items-center justify-center pt-10\n                ",
        "\n              "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

















var EmptyCart = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8977).then(__webpack_require__.bind(__webpack_require__, 78977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78977)
            ];
        }
    },
    ssr: false
});
var SearchBoxMobileInstantSearch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9936), __webpack_require__.e(1913), __webpack_require__.e(6369)]).then(__webpack_require__.bind(__webpack_require__, 46369));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46369)
            ];
        }
    },
    ssr: false
});
var CartIcon = function(param) {
    var cartCircleState = param.cartCircleState, cartNumberState = param.cartNumberState, cart = param.cart, loading = param.loading;
    var ref, ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,es/* oneLine */.f9)(Toolbar_templateObject(), cartCircleState === "show" ? "animate-scale" : "", cartCircleState === "hidden" ? "animate-[scaleAndBounce_.4s_linear_reverse]" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,es/* oneLine */.f9)(_templateObject1(), cartNumberState === "show" ? "animate-number-drop" : ""),
                    children: !loading ? cart === null || cart === void 0 ? void 0 : (ref = cart.contents) === null || ref === void 0 ? void 0 : ref.itemCount : /*#__PURE__*/ (0,jsx_runtime.jsx)(Reload/* Reload */.L, {
                        width: 15,
                        className: "animate-spin motion-reduce:hidden"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "sr-only",
                children: [
                    !loading ? cart === null || cart === void 0 ? void 0 : (ref1 = cart.contents) === null || ref1 === void 0 ? void 0 : ref1.itemCount : "loading",
                    " items in cart, view bag"
                ]
            })
        ]
    });
};
// eslint-disable-next-line react-hooks/exhaustive-deps
var CartIconMemo = /*#__PURE__*/ (0,react.memo)(CartIcon);
/**
 * Primary UI component for user interaction
 */ var ToolbarWithOutMemoried = function(param) {
    var setLoginModalOpen = param.setLoginModalOpen, setMenuOpen = param.setMenuOpen;
    var ref, ref1;
    var ref2 = (0,useCart/* useCart */.j)(), cart = ref2.cart, loading = ref2.loading;
    var ref3 = (0,react.useState)(false), cartOpen = ref3[0], setCartOpen = ref3[1];
    var ref4 = (0,next_auth_react.useSession)(), status = ref4.status, data = ref4.data;
    // Optional: set the analytics user ID
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    index_browser_cjs_default()("setUserToken", data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : ref.UID);
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(false), searching = ref5[0], setSearching = ref5[1];
    var ref6 = (0,react.useState)(0), lastCartQuantity = ref6[0], setLastCartQuantity = ref6[1];
    var ref7 = (0,react.useState)("none"), cartCircleState = ref7[0], setCartCircleState = ref7[1];
    var ref8 = (0,react.useState)("hidden"), cartNumberState = ref8[0], setCartNumberState = ref8[1];
    var close = function() {
        return setSearching(false);
    };
    (0,react.useEffect)(function() {
        if (!loading) {
            if (lastCartQuantity === 0 && cart.contents.itemCount > 0) {
                // Aparece el circulo y cae el numero
                setCartCircleState("none");
                setTimeout(function() {
                    setCartCircleState("show");
                    setTimeout(function() {
                        setCartNumberState("hidden");
                        setTimeout(function() {
                            setCartNumberState("show");
                        }, 100);
                    }, 500);
                }, 1);
            } else if (lastCartQuantity > 0 && cart.contents.itemCount > 0) {
                // Solo cae el numero
                setCartNumberState("hidden");
                setTimeout(function() {
                    setCartNumberState("show");
                }, 100);
            } else if (lastCartQuantity > 0 && cart.contents.itemCount === 0) {
                // Desaparece el circulo
                setCartCircleState("none");
                setTimeout(function() {
                    setCartCircleState("hidden");
                    setTimeout(function() {
                        setCartNumberState("hidden");
                        setCartCircleState("none");
                    }, 500);
                });
            }
            setLastCartQuantity(cart.contents.itemCount);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart,
        loading
    ]);
    (0,useRouteChangeStart/* useRouteChangeStart */.R)(close);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(custom_skeleton_theme/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:justify-[normal] flex h-full items-center justify-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex lg:hidden lg:items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: function() {
                                return setSearching(true);
                            },
                            role: "button",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Search"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* Search */.o, {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        role: "button",
                        className: "ml-6 flex gap-1 lg:ml-0 lg:items-center",
                        style: {
                            zIndex: 4
                        },
                        onClick: function() {
                            if (status === "authenticated") {
                                router.push(routes/* routes.micuenta.index */._.micuenta.index);
                            } else {
                                setMenuOpen(-1);
                                setLoginModalOpen(true);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "u-body u-body--s hidden font-bold text-primary-900 lg:block",
                                children: status === "authenticated" ? data === null || data === void 0 ? void 0 : (ref1 = data.user) === null || ref1 === void 0 ? void 0 : ref1.name : "Inicia sesi\xf3n"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "sr-only",
                                children: "Search"
                            }),
                            status === "authenticated" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserActive/* UserActive */.P, {
                                width: 20,
                                height: 20,
                                "aria-hidden": "true"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(User/* User */.n, {
                                width: 20,
                                height: 20,
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative ml-6 hidden lg:flex lg:items-center",
                        onMouseEnter: function() {
                            return setCartOpen(true);
                        },
                        onMouseLeave: function() {
                            return setCartOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex items-center pr-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart/* Cart */.A, {
                                    className: "h-5 w-5 flex-shrink-0",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIconMemo, {
                                    cartCircleState: cartCircleState,
                                    cartNumberState: cartNumberState,
                                    cart: cart,
                                    loading: loading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,es/* oneLine */.f9)(_templateObject2(), !cartOpen ? "hidden" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute right-[35px] top-[30px] z-0 h-5 w-5 rotate-45 border border-primary-100 bg-white shadow-lg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative z-10 h-full w-full border border-primary-100 bg-white p-6 shadow-lg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute -top-px right-[31px] h-px w-[26px] bg-white"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                    href: routes/* routes.cart */._.cart,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                                        label: "IR A CESTA",
                                                        size: "large-full",
                                                        className: "mb-2",
                                                        as: "a",
                                                        onClick: function() {
                                                            setCartOpen(false);
                                                        }
                                                    })
                                                }),
                                                !loading && cart.contents.itemCount === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "u-body u-body--s text-center normal-case text-primary-600",
                                                            children: "Tu cesta est\xe1 vac\xeda. Echa un ojo a nuestra web. \xa1Hay productos muy interesantes!"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCart, {
                                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                            // @ts-ignore
                                                            className: "my-6 mt-4 opacity-40"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                            href: routes/* routes.cart */._.cart,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                                                label: "IR A CESTA",
                                                                size: "large-full",
                                                                className: "mb-2",
                                                                as: "a",
                                                                onClick: function() {
                                                                    setCartOpen(false);
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_lines/* default */.Z, {
                                                            cart: cart.contents.cart,
                                                            loading: loading
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "u-body u-body--m flex w-full items-center justify-between pt-4",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Env\xedo"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                                        className: "block min-w-[40px]"
                                                                    }) : (0,price/* SumCurrency */.ue)(cart.shippingTotal, cart.shippingTax)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex w-full items-center justify-between pb-5 pt-3",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "u-body u-body--m",
                                                                    children: [
                                                                        "Total",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "u-body--xs pl-2 text-typo-tertiary",
                                                                            children: "(IVA incluido)"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "u-headline u-headline@mobile--h2",
                                                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                                        count: 1,
                                                                        className: "block min-w-[40px]"
                                                                    }) : (0,price/* toCurrency */.j3)(cart.total)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                            href: routes/* routes.cart */._.cart,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                                                label: "IR A CESTA",
                                                                size: "large-full",
                                                                className: "mb-2",
                                                                as: "a",
                                                                onClick: function() {
                                                                    setCartOpen(false);
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                            href: routes/* routes.checkout.datos */._.checkout.datos,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                                                label: "Tramitar pedido",
                                                                size: "large-full",
                                                                style: "secondary",
                                                                as: "a",
                                                                onClick: function() {
                                                                    setCartOpen(false);
                                                                    (0,helpers/* gtmPush */.De)({
                                                                        event: "begin_checkout",
                                                                        ecommerce: {
                                                                            discount: (0,price/* priceToNumber */.Sk)((0,price/* SumCurrency */.ue)(cart.discountTotal, cart.discountTax)),
                                                                            coupon: cart.appliedCoupons,
                                                                            items: (0,normalizeCartItems/* normalizeCartItems */.D)(cart)
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-6 lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                            href: routes/* routes.cart */._.cart,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "relative flex items-center pr-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart/* Cart */.A, {
                                        className: "h-5 w-5 flex-shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIconMemo, {
                                        cartCircleState: cartCircleState,
                                        cartNumberState: cartNumberState,
                                        cart: cart,
                                        loading: loading
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                show: searching,
                as: react.Fragment,
                unmount: false,
                enter: "transition ease-in-out duration-300 transform",
                enterFrom: "translate-x-full",
                enterTo: "translate-x-0",
                leave: "transition ease-in-out duration-300 transform",
                leaveFrom: "translate-x-0",
                leaveTo: "translate-x-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog */.V, {
                    unmount: false,
                    as: "div",
                    className: "fixed inset-0 z-40 flex lg:hidden",
                    onClose: close,
                    open: searching,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-full w-full flex-col items-end bg-bg-secondary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(toast_center/* default */.Z, {
                                className: "lg:hidden",
                                style: {
                                    position: "absolute",
                                    zIndex: 40,
                                    width: "100%",
                                    inset: "auto"
                                }
                            }),
                            searching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBoxMobileInstantSearch, {
                                placeholder: "\xbfQu\xe9 est\xe1s buscando?",
                                onClose: close
                            }) : null
                        ]
                    })
                })
            })
        ]
    });
};
var Toolbar = /*#__PURE__*/ (0,react.memo)(ToolbarWithOutMemoried);

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/Toolbar/index.ts

/* harmony default export */ var desktop_Toolbar = (Toolbar);

;// CONCATENATED MODULE: ./components/molecules/primarymenu/desktop/PreHeader/PreHeader.tsx









/**
 * Primary UI component for user interaction
 */ var PreHeader = function(param) {
    var setLoginModalOpen = param.setLoginModalOpen, setOpen = param.setOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        zIndex: 100,
        wrapper: true,
        padding: "p-0 py-3 lg:pb-0",
        className: "z-50 hidden lg:block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "u-body u-body--xs grid grid-cols-[1fr,_196px,_1fr] items-end gap-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(facade_search_box_desktop, {
                    placeholder: "Busca productos aqu\xed ..."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(initPropsProvider/* InitPropsProvider.Consumer */.J.Consumer, {
                    children: function(param) {
                        var _options = param.options, logo = _options.ajustesGenerales.logo;
                        var logoImage = (0,common_image/* imageTransformer */.p)(logo);
                        return logo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                            href: routes/* routes.index */._.index,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "relative z-[4] mx-auto block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "BIGCRAFTERS"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: logoImage.src,
                                        alt: logoImage.alt,
                                        objectFit: "contain",
                                        objectPosition: "center",
                                        draggable: "false",
                                        priority: true,
                                        width: 192,
                                        height: 56
                                    })
                                ]
                            })
                        }) : null;
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "border-b border-b-primary-200 pb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_Toolbar, {
                        setLoginModalOpen: setLoginModalOpen,
                        setMenuOpen: setOpen
                    })
                })
            ]
        })
    });
};
PreHeader.displayName = "PreHeader";
/* harmony default export */ var PreHeader_PreHeader = (/*#__PURE__*/(0,react.memo)(PreHeader));

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./components/icons/Menu.tsx
var Menu = __webpack_require__(75881);
// EXTERNAL MODULE: ./components/icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(33068);
// EXTERNAL MODULE: ./components/icons/Less.tsx
var Less = __webpack_require__(91175);
// EXTERNAL MODULE: ./components/icons/Add.tsx
var Add = __webpack_require__(40887);
// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js + 4 modules
var debounce = __webpack_require__(8891);
;// CONCATENATED MODULE: ./lib/hooks/useHeaderSticky.ts


var useHeaderSticky = function(ref) {
    var checkIfScrollStoped = (0,react.useMemo)(function() {
        return (0,debounce/* default */.Z)(function() {
            var _$ref;
            if ((_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.style) {
                ref.current.style.top = "0px";
            }
        }, 500);
    }, [
        ref
    ]);
    var prevScrollY = 0;
    var currScrollY = 0;
    var handleScroll = function() {
        var _$ref, _$ref1;
        prevScrollY = currScrollY;
        currScrollY = window.scrollY;
        if (prevScrollY > currScrollY && prevScrollY - currScrollY > 5 && ((_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.style)) {
            ref.current.style.top = "0px";
        } else if (prevScrollY < currScrollY && currScrollY - prevScrollY > 5 && ((_$ref1 = ref.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.style)) {
            ref.current.style.top = "-".concat(ref === null || ref === void 0 ? void 0 : ref.current.clientHeight, "px");
        }
        checkIfScrollStoped();
    };
    (0,react.useEffect)(function() {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        currScrollY = window.scrollY;
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

// EXTERNAL MODULE: ./components/icons/index.ts + 24 modules
var icons = __webpack_require__(72516);
;// CONCATENATED MODULE: ./components/molecules/primarymenu/mobile/Footer/Footer.tsx


/**
 * Primary UI component for user interaction
 */ var FooterMobile = function(param) {
    var button = param.button, socialNetworks = param.socialNetworks;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        children: [
            button,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full justify-around py-4",
                children: // TODO: Añadir tipos
                socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.map(function(item) {
                    var Icon = icons[item.icon];
                    return Icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: item.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    className: "h-6 w-6",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    }, item.icon) : null;
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/primarymenu/mobile/Footer/index.ts

/* harmony default export */ var Footer = (FooterMobile);

// EXTERNAL MODULE: ./components/icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(3967);
;// CONCATENATED MODULE: ./components/molecules/primarymenu/mobile/Header/Header.tsx








/**
 * Primary UI component for user interaction
 */ var HeaderMobile = function(param) {
    var setOpen = param.setOpen;
    var ref;
    var propsProvider = (0,react.useContext)(initPropsProvider/* InitPropsProvider */.J);
    var bcOptions = propsProvider === null || propsProvider === void 0 ? void 0 : (ref = propsProvider.options) === null || ref === void 0 ? void 0 : ref.ajustesGenerales;
    var logoGraphQL = bcOptions === null || bcOptions === void 0 ? void 0 : bcOptions.logoMobile;
    var logo = (0,common_image/* imageTransformer */.p)(logoGraphQL);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between pb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                href: routes/* routes.index */._.index,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "relative block h-9 w-32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: logo.src,
                        alt: logo.alt,
                        layout: "fill",
                        objectFit: "contain",
                        objectPosition: "center",
                        draggable: "false"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "text-gray-400 -m-2 inline-flex items-center justify-center rounded-md p-2",
                onClick: function() {
                    return setOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Close menu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* CloseIcon */.T, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/primarymenu/mobile/MobileMenu.tsx

function MobileMenu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "relative z-[100] flex h-full w-full flex-col bg-white px-4 py-6 \n              ",
        ""
    ]);
    MobileMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















/**
 * MobileMenu
 */ var MobileMenu = function(param) {
    var open = param.open, setOpen = param.setOpen, setOpenModal = param.setOpenModal, setLoginModalOpen = param.setLoginModalOpen;
    var ref = (0,react.useState)(-1), subMenuOpen = ref[0], setSubmenuOpen = ref[1];
    var ref1 = (0,react.useContext)(initPropsProvider/* InitPropsProvider */.J), ajustesGenerales = ref1.options.ajustesGenerales, _menus = ref1.menus, menus = _menus.primaryMenu.menus;
    var logo = (0,common_image/* imageTransformer */.p)(ajustesGenerales.logoMobile);
    (0,useRouteChangeStart/* useRouteChangeStart */.R)(function() {
        return setOpen(false);
    });
    var ref2 = (0,react.useRef)(null);
    useHeaderSticky(ref2);
    var ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        ref: ref2,
        "aria-label": "Top",
        className: "sticky top-0 z-40 transition-all",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-7xl border-b border-b-primary-100 bg-bg-primary px-4 py-[6px] sm:px-6 lg:hidden lg:border-t lg:border-t-primary-900 lg:px-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex h-[46px] items-center lg:py-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-1 items-center justify-between lg:items-start lg:gap-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center gap-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "lg:hidden",
                                        onClick: function() {
                                            setOpen(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Open menu"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu */.v, {
                                                className: "h-6 w-6",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }),
                                    logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                        href: routes/* routes.index */._.index,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "relative h-[42px] w-[140px]",
                                            "aria-label": "Ir a la home",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: logo.src,
                                                alt: logo.alt,
                                                layout: "fill",
                                                objectFit: "contain",
                                                objectPosition: "center",
                                                draggable: "false",
                                                priority: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_Toolbar, {
                                setLoginModalOpen: setLoginModalOpen,
                                setMenuOpen: setOpenModal
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
                show: open,
                as: react.Fragment,
                unmount: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
                    as: "div",
                    className: "fixed inset-0 z-40 flex lg:hidden",
                    onClose: setOpen,
                    unmount: false,
                    open: open,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            unmount: false,
                            as: react.Fragment,
                            enter: "transition-opacity ease-linear duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "transition-opacity ease-linear duration-300",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed inset-0 bg-black bg-opacity-25"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            unmount: false,
                            as: react.Fragment,
                            enter: "transition ease-in-out duration-300 transform",
                            enterFrom: "-translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transition ease-in-out duration-300 transform",
                            leaveFrom: "translate-x-0",
                            leaveTo: "-translate-x-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,es/* oneLine */.f9)(MobileMenu_templateObject(), subMenuOpen === -1 ? "overflow-y-auto" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {
                                        setOpen: function() {
                                            setOpen(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-grow flex-col py-4",
                                        children: menus === null || menus === void 0 ? void 0 : menus.map(function(menu, index) {
                                            var ref, ref1, ref2;
                                            return !menu.column && (menu === null || menu === void 0 ? void 0 : (ref = menu.parentMenuLink) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                href: (ref3 = menu === null || menu === void 0 ? void 0 : (ref1 = menu.parentMenuLink) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref3 !== void 0 ? ref3 : "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "u-body u-body--l py-4 normal-case",
                                                    children: menu.parentMenu
                                                })
                                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex w-full cursor-pointer justify-between py-4",
                                                        onClick: function() {
                                                            return setSubmenuOpen(index);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "u-body u-body--l normal-case",
                                                                children: menu.parentMenu
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* ChevronDown */._, {
                                                                className: "-rotate-90",
                                                                color: "var(--tw-color-secondary-500)"
                                                            })
                                                        ]
                                                    }),
                                                    menu.column && /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                        show: index === subMenuOpen,
                                                        as: react.Fragment,
                                                        enter: "transition ease-in-out duration-300 transform",
                                                        enterFrom: "-translate-x-full",
                                                        enterTo: "translate-x-0",
                                                        leave: "transition ease-in-out duration-300 transform",
                                                        leaveFrom: "translate-x-0",
                                                        leaveTo: "-translate-x-full",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "absolute left-0 top-0 z-[100] flex h-full w-full flex-col overflow-y-auto bg-white px-4 py-6",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderMobile, {
                                                                    setOpen: function() {
                                                                        setOpen(false);
                                                                        setSubmenuOpen(-1);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    onClick: function() {
                                                                        return setSubmenuOpen(-1);
                                                                    },
                                                                    className: "flex cursor-pointer items-end justify-start gap-6 border-b border-b-primary-100 py-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* ChevronDown */._, {
                                                                            className: "relative top-[1px] rotate-90",
                                                                            color: "var(--tw-color-secondary-500)",
                                                                            height: 24,
                                                                            width: 24
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "u-body u-body--l normal-case",
                                                                            children: menu.parentMenu
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex flex-grow flex-col items-start py-4",
                                                                    children: menu.column.map(function(column) {
                                                                        return column.bloque.map(function(bloque, index) {
                                                                            var ref;
                                                                            return bloque.subMenuMobile && bloque.menuPages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                                                                children: function(param) {
                                                                                    var open = param.open;
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                                                                                as: "div",
                                                                                                className: "flex w-full items-center justify-between py-4",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                        className: "u-body u-body--m normal-case text-primary-600",
                                                                                                        children: bloque.title
                                                                                                    }),
                                                                                                    open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Less/* Less */.v, {
                                                                                                        color: "#F68217",
                                                                                                        width: 24,
                                                                                                        height: 24
                                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* Add */.m, {
                                                                                                        color: "#F68217",
                                                                                                        width: 24,
                                                                                                        height: 24
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                                                                unmount: false,
                                                                                                className: "flex w-full flex-col p-4",
                                                                                                as: "ul",
                                                                                                children: bloque === null || bloque === void 0 ? void 0 : bloque.menuPages.map(function(menuPage, index) {
                                                                                                    var ref;
                                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                                        className: "w-full py-4",
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                                                                            href: (ref4 = menuPage === null || menuPage === void 0 ? void 0 : (ref = menuPage.pageUrl) === null || ref === void 0 ? void 0 : ref.url) !== null && ref4 !== void 0 ? ref4 : "/",
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                                className: "u-body u-body--m normal-case text-primary-400",
                                                                                                                children: menuPage.pageTitle
                                                                                                            })
                                                                                                        })
                                                                                                    }, index);
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    });
                                                                                }
                                                                            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                                                href: (ref5 = bloque === null || bloque === void 0 ? void 0 : (ref = bloque.page) === null || ref === void 0 ? void 0 : ref.url) !== null && ref5 !== void 0 ? ref5 : "/",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    className: "u-body u-body--m w-full py-4 normal-case text-primary-600",
                                                                                    children: bloque.title
                                                                                })
                                                                            }, index);
                                                                        });
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                                                    socialNetworks: ajustesGenerales.socialNetworks,
                                                                    button: (menu === null || menu === void 0 ? void 0 : (ref2 = menu.parentMenuLink) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                                                        href: menu.parentMenuLink.url,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                                                            label: menu.parentMenu,
                                                                            size: "large-full",
                                                                            style: "primary",
                                                                            as: "a"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                        socialNetworks: ajustesGenerales.socialNetworks,
                                        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                            href: routes/* routes.joinBigCrafters */._.joinBigCrafters,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                                label: "\xfanete a bigcrafters\xae",
                                                size: "large-full",
                                                style: "secondary",
                                                as: "a"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(toast_center/* default */.Z, {
                className: "lg:hidden"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/molecules/primarymenu/mobile/index.ts

/* harmony default export */ var mobile = (MobileMenu);

// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
;// CONCATENATED MODULE: ./components/organisms/header/Header.tsx


function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "      \n          ",
        "\n          top-0 z-50 transition-all\n        "
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            fixed inset-0 -z-10 bg-gray-500 bg-opacity-75 backdrop-blur-sm transition-opacity\n            ",
        "\n          "
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            z-50 h-full border-b-0 border-b-primary-100 bg-bg-primary lg:border-b\n            ",
        "\n          "
    ]);
    Header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var LoginModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5677), __webpack_require__.e(6584)]).then(__webpack_require__.bind(__webpack_require__, 69668));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69668)
            ];
        }
    },
    ssr: false
});
// TODO tipar los datos
function Header() {
    var ref = (0,react.useState)(-1), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), openMobile = ref1[0], setOpenMobile = ref1[1];
    var ref2 = (0,react.useState)(false), loginModalOpen = ref2[0], setLoginModalOpen = ref2[1];
    var ref3 = (0,react.useState)(false), headerOutOfBounds = ref3[0], setHeaderOutOfBounds = ref3[1];
    var router = (0,next_router.useRouter)();
    var withOutSticky = (0,utils/* isCartRoute */._O)(router.pathname) || (0,utils/* isMyAccountRoute */.c_)(router.pathname);
    var ref4 = (0,react.useRef)(null);
    useHeaderSticky(ref4);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref4.current) {
                var ref;
                setHeaderOutOfBounds((ref4 === null || ref4 === void 0 ? void 0 : (ref = ref4.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().bottom) < 0);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile, {
                open: openMobile,
                setOpen: setOpenMobile,
                setOpenModal: setOpen,
                setLoginModalOpen: setLoginModalOpen,
                className: withOutSticky ? "" : "sticky"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: ref4,
                className: (0,es/* oneLine */.f9)(Header_templateObject(), withOutSticky ? "" : "sticky"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,es/* oneLine */.f9)(Header_templateObject1(), open >= 0 ? "opacity-100" : "pointer-events-none opacity-0"),
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,es/* oneLine */.f9)(Header_templateObject2(), withOutSticky ? "" : "sticky"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                className: "relative bg-bg-primary px-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreHeader_PreHeader, {
                                        setLoginModalOpen: setLoginModalOpen,
                                        setOpen: setOpen
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop, {
                                        open: open,
                                        setOpen: setOpen
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal, {
                                show: loginModalOpen,
                                setLoginModalOpen: setLoginModalOpen,
                                onSuccess: function() {
                                    return setLoginModalOpen(false);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(toast_center/* default */.Z, (0,_object_spread/* default */.Z)({
                        className: "hidden lg:block"
                    }, headerOutOfBounds && withOutSticky ? {
                        style: {
                            position: "fixed",
                            zIndex: -10,
                            width: "100%",
                            inset: "auto",
                            top: 0
                        }
                    } : {
                        style: {
                            position: "absolute",
                            zIndex: -10,
                            width: "100%",
                            inset: "auto"
                        }
                    }))
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/organisms/header/index.tsx

/* harmony default export */ var header = (Header);


/***/ }),

/***/ 12334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ snackbar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(16434);
// EXTERNAL MODULE: ./components/icons/Reloj.tsx
var Reloj = __webpack_require__(40745);
// EXTERNAL MODULE: ./components/icons/Copy.tsx
var Copy = __webpack_require__(46855);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./components/molecules/button/index.ts + 1 modules
var molecules_button = __webpack_require__(25634);
;// CONCATENATED MODULE: ./components/atoms/date-time/DateTime.tsx


/**
 * DateTime
 */ var DateTime = /*#__PURE__*/ (0,react.memo)(function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, time = param.time, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "inline-block",
                children: time
            }),
            type
        ]
    });
});
DateTime.displayName = "DateTime";

;// CONCATENATED MODULE: ./components/atoms/date-time/index.ts

/* harmony default export */ var date_time = (DateTime);

;// CONCATENATED MODULE: ./components/molecules/counter/Counter.tsx


/**
 * Counter
 */ var Counter = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: 'u-label u-label--s flex flex-row items-center gap-0.5 [&_div]:before:mr-0.5 [&_div]:before:content-["•"] first:[&_div]:before:content-[""] '.concat(className),
        children: [
            days && /*#__PURE__*/ (0,jsx_runtime.jsx)(date_time, {
                time: days,
                type: "D"
            }),
            hours && /*#__PURE__*/ (0,jsx_runtime.jsx)(date_time, {
                time: hours,
                type: "H"
            }),
            minutes && /*#__PURE__*/ (0,jsx_runtime.jsx)(date_time, {
                time: minutes,
                type: "M"
            }),
            seconds && /*#__PURE__*/ (0,jsx_runtime.jsx)(date_time, {
                time: seconds,
                type: "S",
                className: days ? "hidden 2xl:block" : ""
            })
        ]
    });
};
Counter.displayName = "Counter";

;// CONCATENATED MODULE: ./components/molecules/counter/index.ts

/* harmony default export */ var counter = (Counter);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
;// CONCATENATED MODULE: ./lib/hooks/useClipboard.ts



/**
 * Hook to copy text to clipboard.
 * @param  {string} str String to copy
 * @return {[boolean, () => void]} [copied, copyAction]
 */ var useClipboard = function(str) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    var copyableString = (0,react.useRef)(str);
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    var copyAction = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            navigator === null || navigator === void 0 ? void 0 : (ref = navigator.clipboard) === null || ref === void 0 ? void 0 : ref.writeText(copyableString.current).then(function() {
                return setCopied(true);
            }).catch(function() {
                return setCopied(false);
            }).finally(function() {
                return setTimeout(function() {
                    return setCopied(false);
                }, timeout);
            });
            return [
                2
            ];
        });
    }), [
        copyableString
    ]);
    (0,react.useEffect)(function() {
        copyableString.current = str;
    }, [
        str
    ]);
    return [
        copied,
        copyAction
    ];
};

;// CONCATENATED MODULE: ./components/organisms/snackbar/Snackbar.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "bg-primary-900 ",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "bg-primary-900 px-2 py-2 md:py-3 ",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "u-wrapper flex gap-2 md:gap-7 lg:gap-20 ",
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








/**
 * Snackbar
 */ var Snackbar = function(param) {
    var type = param.type, message = param.message, Icon = param.Icon, button = param.button, code = param.code, countdown = param.countdown, backgroundColor = param.backgroundColor, textColor = param.textColor, _className = param.className, className = _className === void 0 ? "" : _className;
    var ref = (0,_sliced_to_array/* default */.Z)(useClipboard(code !== null && code !== void 0 ? code : ""), 2), copied = ref[0], copy = ref[1];
    var ref1 = (0,react.useState)(false), completed = ref1[0], setcompleted = ref1[1];
    if (type === "simple") {
        var ref2, ref3;
        var ref4, ref5, ref6;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,es/* oneLine */.f9)(_templateObject(), className),
            style: {
                color: textColor,
                backgroundColor: backgroundColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between md:justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center gap-6 py-2 pl-2 md:py-3 md:pr-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center gap-2",
                                children: [
                                    Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        height: 24,
                                        width: 24,
                                        color: textColor,
                                        className: "shrink-0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "u-body u-body--s md:u-body--xl",
                                        dangerouslySetInnerHTML: {
                                            __html: message
                                        }
                                    })
                                ]
                            }),
                            button && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                                href: (ref4 = button === null || button === void 0 ? void 0 : (ref2 = button.link) === null || ref2 === void 0 ? void 0 : ref2.url) !== null && ref4 !== void 0 ? ref4 : "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_button/* default */.Z, {
                                    as: "a",
                                    label: (ref5 = button === null || button === void 0 ? void 0 : button.label) !== null && ref5 !== void 0 ? ref5 : "",
                                    size: button === null || button === void 0 ? void 0 : button.size,
                                    negative: button === null || button === void 0 ? void 0 : button.negativo,
                                    style: button === null || button === void 0 ? void 0 : button.style,
                                    className: "!hidden md:!flex"
                                })
                            })
                        ]
                    }),
                    button && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                        href: (ref6 = button === null || button === void 0 ? void 0 : (ref3 = button.link) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref6 !== void 0 ? ref6 : "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            role: "button",
                            className: "flex w-[26px] shrink-0 bg-primary-900 md:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* ChevronRight */._, {
                                height: 12,
                                width: 12,
                                color: "#FFFFFF",
                                className: "mx-auto self-center"
                            })
                        })
                    })
                ]
            })
        });
    }
    if (completed && countdown && type === "countdown") {
        return null;
    }
    if (type === "countdown") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,es/* oneLine */.f9)(_templateObject1(), className),
            style: {
                color: textColor,
                backgroundColor: backgroundColor
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,es/* oneLine */.f9)(_templateObject2(), countdown || code ? "justify-between" : "justify-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "u-body u-body--xs self-center md:u-body--s prose-a:font-medium prose-a:underline",
                        dangerouslySetInnerHTML: {
                            __html: message
                        }
                    }),
                    countdown || code ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex shrink-0 flex-col items-end gap-[2px] divide-[#C76913] lg:flex-row lg:items-center lg:gap-4 lg:divide-x",
                        children: [
                            countdown && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center justify-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reloj/* Reloj */.m, {
                                        color: textColor,
                                        width: 16,
                                        height: 16,
                                        className: "shrink-0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                                        date: countdown,
                                        onMount: function(e) {
                                            return setcompleted(e.completed);
                                        },
                                        renderer: function(param) {
                                            var completed = param.completed, days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds;
                                            return completed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "u-body u-body--xs",
                                                children: "Finalizado"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(counter, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                className: "u-body u-body--xs font-bold md:u-body--s"
                                            }, days > 0 && {
                                                days: (0,index_es/* zeroPad */.Bu)(days)
                                            }), {
                                                hours: (0,index_es/* zeroPad */.Bu)(hours),
                                                minutes: (0,index_es/* zeroPad */.Bu)(minutes),
                                                seconds: (0,index_es/* zeroPad */.Bu)(seconds)
                                            }));
                                        }
                                    })
                                ]
                            }),
                            code && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "u-body u-body--xs flex cursor-pointer flex-nowrap md:u-body--s md:pl-4",
                                onClick: copy,
                                children: copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "\xa1Copiado!"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-[2px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "whitespace-nowrap",
                                            children: [
                                                "C\xf3digo: ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold",
                                                    children: code
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Copy/* Copy */.C, {
                                            color: textColor,
                                            width: 16,
                                            height: 16,
                                            className: "shrink-0"
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            })
        });
    }
    return null;
};
/* harmony default export */ var snackbar_Snackbar = (/*#__PURE__*/(0,react.memo)(Snackbar));

;// CONCATENATED MODULE: ./components/organisms/snackbar/index.ts

/* harmony default export */ var snackbar = (snackbar_Snackbar);


/***/ }),

/***/ 47831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toast_center; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
// EXTERNAL MODULE: ./components/icons/Close.tsx
var Close = __webpack_require__(44504);
// EXTERNAL MODULE: ./components/atoms/next-link/index.ts + 1 modules
var next_link = __webpack_require__(7842);
// EXTERNAL MODULE: ./lib/hooks/useToastDispatch.ts
var useToastDispatch = __webpack_require__(75587);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(82702);
;// CONCATENATED MODULE: ./components/molecules/toast/Toast.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        flex w-full flex-row justify-center gap-2 px-4 py-3 will-change-transform \n        ",
        " \n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/**
 * Toast
 */ var Toast = function(param) {
    var backgroundColor = param.backgroundColor, id = param.id, message = param.message, visible = param.visible, Icon = param.Icon, _className = param.className, className = _className === void 0 ? "" : _className, link = param.link;
    var closeToast = (0,useToastDispatch/* useToastDispatch */.y)().closeToast;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,es/* oneLine */.f9)(_templateObject(), visible ? "animate-toast-out" : "animate-toast-in", className),
        style: {
            backgroundColor: backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center gap-2",
                children: [
                    Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        width: 19,
                        height: 19,
                        color: "#FFFFFF",
                        className: "shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "u-body u-body--xs text-white",
                        children: message
                    }),
                    link && link.type === "url" && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link/* default */.Z, {
                        href: (0,utils/* removeBaseURL */.t7)(link.url),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "u-body u-body--xs font-bold normal-case text-primary-50 underline",
                            children: link.label
                        })
                    }),
                    link && link.type === "action" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "u-body u-body--xs font-bold normal-case text-primary-50 underline",
                        onClick: function() {
                            return link.action(id);
                        },
                        children: link.label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: function() {
                    closeToast(id);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {
                    height: 19,
                    width: 19,
                    className: "cursor-pointer",
                    color: "#FFFFFF"
                })
            })
        ]
    });
};
/* harmony default export */ var toast_Toast = (/*#__PURE__*/(0,react.memo)(Toast));

;// CONCATENATED MODULE: ./components/molecules/toast/index.ts

/* harmony default export */ var molecules_toast = (toast_Toast);

// EXTERNAL MODULE: ./components/providers/ToastProvider.tsx + 1 modules
var ToastProvider = __webpack_require__(35954);
;// CONCATENATED MODULE: ./lib/hooks/useToast.ts


var useToast = function() {
    return (0,react.useContext)(ToastProvider/* ToastContext */.uL);
};

;// CONCATENATED MODULE: ./components/organisms/toast-center/ToastCenter.tsx






/**
 * ToastCenter
 */ var ToastCenter = function(param) {
    var className = param.className, _style = param.style, style = _style === void 0 ? {
        position: "absolute",
        zIndex: -10,
        width: "100%",
        inset: "auto"
    } : _style, children = param.children;
    var toast = useToast();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, className && {
        className: className
    }), {
        style: style,
        children: toast.map(function(t) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    position: "absolute",
                    transition: "all 230ms cubic-bezier(0.21, 1.02, 0.73, 1) 0s",
                    zIndex: t.visible ? 10 : -10,
                    width: "100%",
                    justifyContent: "center"
                },
                children: children ? children(t) : /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_toast, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, t), {
                    className: "".concat(t.visible ? "animate-toast-out" : "animate-toast-in")
                }))
            }, t.id);
        })
    }));
};
/* harmony default export */ var toast_center_ToastCenter = (/*#__PURE__*/(0,react.memo)(ToastCenter));

;// CONCATENATED MODULE: ./components/organisms/toast-center/index.tsx

/* harmony default export */ var toast_center = (toast_center_ToastCenter);


/***/ }),

/***/ 59197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useCart; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_providers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57333);


var useCart = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_components_providers__WEBPACK_IMPORTED_MODULE_1__/* .CartContext */ .A9);
    if (!context) throw Error("useCart must be used within CartProvider");
    return context;
};


/***/ }),

/***/ 60556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useRouteChangeStart; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Hook to execute a callback when a route changed start.
 * @param  {() => void} callback Function that will be executed when route is started.
 */ var useRouteChangeStart = function(callback) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        router.events.on("routeChangeStart", callback);
        return function() {
            return router.events.off("routeChangeStart", callback);
        };
    }, [
        callback,
        router
    ]);
};


/***/ }),

/***/ 2671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ normalizeCartItems; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _price__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86359);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20457);



var normalizeCartItems = function(data) {
    var ref;
    //TODO: coger el cupon anadido a cada producto
    //TODO: anadir productos También te puede interesar
    //TODO: anadir la marca del producto --to discuss with the team
    var cartItems = data === null || data === void 0 ? void 0 : (ref = data.contents) === null || ref === void 0 ? void 0 : ref.edges;
    var items = [];
    if (cartItems) {
        cartItems.forEach(function(element, index) {
            var ref;
            var product;
            var productVariation = element.node.variation;
            if (productVariation) {
                product = productVariation.node;
            } else {
                product = element.node.product.node;
            }
            var onSale = element.node.product.node.onSale;
            var discount;
            if (onSale) {
                discount = Number.parseFloat((0,_price__WEBPACK_IMPORTED_MODULE_0__/* .getDiscountAmount */ .TC)((0,_price__WEBPACK_IMPORTED_MODULE_0__/* .priceToNumber */ .Sk)(product.regularPrice), (0,_price__WEBPACK_IMPORTED_MODULE_0__/* .priceToNumber */ .Sk)(product.salePrice)).toFixed(2));
            }
            var brand = element.node.product.node.caracteriSticasDelProducto.datosDeProducto.marca;
            var seller = product.sellerInfo.name === "Bigcrafters" ? _helpers__WEBPACK_IMPORTED_MODULE_1__/* .AFFILIATION_NAME_OPERATOR */ .lZ : product.sellerInfo.name;
            var quantity = element.node.quantity;
            var item = {
                item_id: product.sku,
                item_name: product.name,
                affiliation: seller,
                currency: "EUR",
                discount: onSale && discount ? discount * quantity : null,
                index: index,
                item_brand: Array.isArray(brand) ? (ref = brand[0]) === null || ref === void 0 ? void 0 : ref.slug : null,
                item_list_id: null,
                item_list_name: null,
                item_variant: productVariation ? product.sku : null,
                price: (0,_price__WEBPACK_IMPORTED_MODULE_0__/* .priceToNumber */ .Sk)(product.regularPrice) * quantity,
                quantity: quantity
            };
            if (element.node.product.node.productCategories) {
                var categories = (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getProductCategoriesTree */ .BI)(element.node.product.node);
                item = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, item, categories);
            }
            items.push(item);
        });
    }
    return items;
};


/***/ }),

/***/ 43688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ imageWithFallback; }
/* harmony export */ });
var hasValue = function(value) {
    return value && value !== "";
};
var srcWithFallback = function(src, fallbackIMG) {
    return hasValue(src) ? src : fallbackIMG;
};
var altWithFallback = function(alt) {
    return hasValue(alt) ? alt : "Im\xe1gen";
};
var imageWithFallback = function(src, alt, fallbackIMG) {
    return {
        src: srcWithFallback(src, fallbackIMG),
        alt: altWithFallback(alt)
    };
};


/***/ }),

/***/ 87007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ repeat; }
/* harmony export */ });
/* unused harmony export generateImages */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var repeat = function(n, element) {
    return /* TODO: Arreglar tipos */ /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Array(n)).map(function(_, i) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(element.type, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, element.props), {
            key: i
        }));
    });
};
var generateImages = function() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, sig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Array.from({
        length: length
    }).map(function(_, index) {
        index = sig || index;
        return {
            src: "https://source.unsplash.com/random/800x450?sig=".concat(index),
            alt: "Image ".concat(index),
            width: 800,
            height: 450
        };
    });
};


/***/ }),

/***/ 16401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"o-input":"Input_o-input__z5qjU","o-input__field":"Input_o-input__field__mHD6K","o-input__field--hidden":"Input_o-input__field--hidden__JoxbO","o-input__field--error":"Input_o-input__field--error__Q1_TA"};

/***/ }),

/***/ 31337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-price":"Price_c-price__90PSi","c-price__regular-price":"Price_c-price__regular-price__a0dmH","c-price__price":"Price_c-price__price___DUmn","c-price__price-sale":"Price_c-price__price-sale__HaaNo","c-price--description":"Price_c-price--description__7y1Df"};

/***/ }),

/***/ 65066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-cart-line":"CartLine_c-cart-line__tMz4L","c-cart-line__content":"CartLine_c-cart-line__content__31WtF","c-cart-line__image":"CartLine_c-cart-line__image__MT__R","c-cart-line__name":"CartLine_c-cart-line__name__lNSgC","c-cart-line--large":"CartLine_c-cart-line--large__hI1yE"};

/***/ }),

/***/ 31925:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"o-number":"number_o-number__tXmXR","o-number__wrapper":"number_o-number__wrapper__TE3Vb","o-number__more":"number_o-number__more__K1249","o-number__less":"number_o-number__less__Oe4im","o-number__more--disabled":"number_o-number__more--disabled__ckPlE","o-number__less--disabled":"number_o-number__less--disabled__Nyom1","o-number__field":"number_o-number__field__2kQr_","o-number__field--error":"number_o-number__field--error__mQ7yZ","o-number__errorMessage":"number_o-number__errorMessage__2v1gM"};

/***/ }),

/***/ 53264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"c-prose":"Prose_c-prose___MuFk"};

/***/ })

}]);